const times = [
  {
    id: "FAST SHIPPING | within 7 days",
    value: 7,
  },
  {
    id: "1 WEEK",
    value: 7,
  },
  {
    id: "2 WEEKS",
    value: 14,
  },
  {
    id: "3 WEEKS",
    value: 21,
  },
  {
    id: "4 WEEKS",
    value: 28,
  },
  {
    id: "6 WEEKS",
    value: 42,
  },
  {
    id: "Within 60 days",
    value: 60,
  },
  {
    id: "Within 90 days",
    value: 90,
  },
  {
    id: "Within 120 days",
    value: 120,
  },
  {
    id: "Within 150 days",
    value: 150,
  },
  {
    id: "Within 180 days",
    value: 180,
  },
];

function getDeliveryDates(date, from, locale = "EN") {
  if (!date) {
    return getDefaultDates(from ?  new Date(from) : new Date());
  }
  
  const time = times.find((x) => x.id === date);

  let startDate = from ? new Date(from) : new Date();
  let endDate = from ? new Date(from) : new Date();

  // add 5 shipping days
  startDate.setDate(startDate.getDate() + time.value);

  // add shipping time to date
  endDate.setDate(endDate.getDate() + time.value + 7);

  const opt = { month: "short", day: "numeric" };

  const s = `${new Date(startDate).toLocaleDateString(locale, opt)}-${new Date(
    endDate
  ).toLocaleDateString(locale, opt)}`;
  return s;
}

function getDefaultDates(from) {
  const market = marketHandle;
  s = [3, 15];
  if (market == "eu" || market == "europe") s = [2, 8];
  if (market == "it") s = [2, 6];

  bD = from ? new Date(from) : new Date();
  b = 5;
  while (b > 0) {
    bD.setDate(bD.getDate() + 1);
    if (bD.getDay() != 0 && bD.getDay() != 6) {
      b -= 1;
    }
  }

  minDate = new Date(bD);
  i = s[0];
  while (i > 0) {
    minDate.setDate(minDate.getDate() + 1);
    if (minDate.getDay() != 0 && minDate.getDay() != 6) {
      i -= 1;
    }
  }

  maxDate = new Date(bD);
  y = s[1];
  while (y > 0) {
    maxDate.setDate(maxDate.getDate() + 1);
    if (maxDate.getDay() != 0 && maxDate.getDay() != 6) {
      y -= 1;
    }
  }

  const locale = "EN";
  opt = { month: "short", day: "numeric" };
  string = `${new Date(
    minDate
  ).toLocaleDateString(locale, opt)}-${new Date(maxDate).toLocaleDateString(
    locale,
    opt
  )}`;
  return string;
}
